import './bookings-payment.css'
import './static/pin-checkmark.svg'
import './static/shield.svg'
